"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var core_1 = require("@emotion/core");
require("balloon-css");
function Tooltip(_a) {
  var children = _a.children,
    label = _a.label,
    position = _a.position,
    visible = _a.visible,
    _b = _a.size,
    size = _b === void 0 ? 'sm' : _b;
  var props = {
    'aria-label': label,
    'data-balloon-pos': position || 'up',
    'data-balloon-visible': false,
    'data-balloon-length': size
  };
  if (visible) {
    props['data-balloon-visible'] = true;
  } else {
    delete props['data-balloon-visible'];
  }
  if (!label) {
    return react_1.default.createElement("span", {
      className: "inline-block"
    }, children);
  }
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(core_1.Global, {
    styles: core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          body.mode-dark .invertase-ui-tooltip {\n            --balloon-color: #fff;\n\n            &:after {\n              color: #000 !important;\n            }\n          }\n        "], ["\n          body.mode-dark .invertase-ui-tooltip {\n            --balloon-color: #fff;\n\n            &:after {\n              color: #000 !important;\n            }\n          }\n        "])))
  }), react_1.default.createElement("span", __assign({
    className: "inline-block invertase-ui-tooltip"
  }, props), children));
}
exports.Tooltip = Tooltip;
var templateObject_1;